
<template>
	<im-table 
		v-if="!loading"	
		:loading="loading"
		:model="sites"
		:url="buildUrl"
		@getAll="getAll"
		@delete="deleteRequest">
		<template slot="columns">
			<el-table-column
				:min-width="25"
				prop="clientName"
				label="Clienti" />
			<el-table-column
				:min-width="20" 
				prop="name"
				label="Cantiere" />
			<el-table-column
				:min-width="20" 
				label="Email principale">
				<template slot-scope="scope">
					{{primaryEmailField(scope.row.emails,'email')}}
				</template>
			</el-table-column>
			<el-table-column
				:min-width="20" 
				label="Contatto email principale">
				<template slot-scope="scope">
					{{primaryEmailField(scope.row.emails,'contactName')}}
				</template>
			</el-table-column>
		</template>
	</im-table>
	<loading v-else />
</template>
<script>
import { Table, TableColumn, Pagination } from 'element-ui'
import { mapState, mapActions } from 'vuex'

export default{
	name: 'sites-table',
	components: {
		[TableColumn.name]: TableColumn,
	},
	computed: {
		...mapState({
			sites: state => state.sites.sites,
			loading: state => state.sites.loading
		})
	},
	created() {
		this.getAll()
	},
	methods: {
		...mapActions('sites', {
		  getAll: 'getAll',
		  delete: 'delete'
		}),
		buildUrl(scope) {
			return `/sites/${scope.row.id}`
		},
		deleteRequest(scope) {
			this.delete(scope.row.id)
		},
		primaryEmailField(emails,field) {
			var emails = emails.filter(email => email.primary);
			return emails.length ? emails[0][field] : '';
		}
	},
}
</script>